import { render, staticRenderFns } from "./DAutoPage.vue?vue&type=template&id=843234ec&scoped=true"
import script from "./DAutoPage.vue?vue&type=script&lang=js"
export * from "./DAutoPage.vue?vue&type=script&lang=js"
import style0 from "./DAutoPage.vue?vue&type=style&index=0&id=843234ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843234ec",
  null
  
)

export default component.exports